import React from "react";

import { TextField } from "@mui/material";

import { IgAutocomplete } from "./IgAutocomplete";

interface IgFilterAutocompleteProps {
  selectedValues?: string[] | null;
  allDataOptions: string[];
  filterKey: "customEvents" | "countryCodes";
  placeholder: string;
  getOptionLabel?: (option: any) => string;
  onChange: (
    values: string[],
    filterKey: "customEvents" | "countryCodes"
  ) => void;
  disableCloseOnSelect?: boolean;
}
export const IgFilterAutocomplete = ({
  placeholder,
  selectedValues,
  allDataOptions,
  getOptionLabel,
  onChange,
  filterKey,
  disableCloseOnSelect,
}: IgFilterAutocompleteProps) => {
  return (
    <IgAutocomplete
      disableCloseOnSelect={disableCloseOnSelect ?? false}
      multiple={true}
      sx={{ minWidth: "240px" }}
      onChange={(event, value) => {
        onChange(value, filterKey);
      }}
      options={allDataOptions}
      getOptionLabel={getOptionLabel}
      value={selectedValues}
      filterSelectedOptions={true}
      renderInput={(params) => (
        <TextField
          {...params}
          sx={{
            "& .MuiInputBase-input": {
              fontSize: "14px",
            },
          }}
          size={"small"}
          variant={"outlined"}
          placeholder={placeholder}
        />
      )}
    />
  );
};
